import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input} from 'reactstrap';
import {validMail, validName, validString} from "../../validation";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import {setErrorProfile, signUp} from "../../reducers/profile/actions";
import {login} from "../../sagas";

function ModalSignUp({isLoaded, isError, signUp, clearError, toggle, setSuccessText, toggleSuccess, isOpen}) {

    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [prevOpen, setPrevOpen] = useState(false);

    useEffect(() => {
        if (isOpen && isError) {
            clearError();
            alert('Invalid Data');
        }

        if (prevOpen !== isOpen) {
            if (isOpen) {
                initState();
            }
            setPrevOpen(isOpen);
        }
    });

    function initState() {
        setEmail('');
        setName('');
    }

    const handleInputName = (evt) => setName(evt.target.value);
    const handleInputEmail = (evt) => setEmail(evt.target.value);

    const isValidEmail = () => {
        console.log(email);
        const str = email.trim();
        return validString(str) && validMail(str)
    };

    const isValidName = () => {
        console.log(name);
        const str = name.trim();
        return validString(str) && validName(str)
    };

    const sendForm = () => {
        if (isValidEmail() && isValidName()) {
            const data = {email: email.trim(), name: name.trim()},
                successCB = () => {
                    toggle();
                    setSuccessText('Thank you for the application, it is sent for approval');
                    toggleSuccess();
                };
            return signUp({data, successCB});
        }
        if (!isValidEmail()) {
            alert('Invalid Email');
            return;
        }
        if (!isValidName()) {
            alert('Invalid Name');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            sendForm();
        }
    };

    return (
        <div>
            <Modal isOpen={isOpen}>
                <ModalHeader toggle={isLoaded ? null : toggle}>Sign Up</ModalHeader>
                <ModalBody>
                    <Form onSubmit={sendForm}>
                        <FormGroup>
                            <Label for="exampleName">Name</Label>
                            <Input type="name" name="name" id="exampleName" placeholder="Name"
                                   value={name} onChange={handleInputName} onKeyPress={handleKeyPress}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="exampleEmail">Email</Label>
                            <Input type="email" name="email" id="exampleEmail" placeholder="Email"
                                   value={email} onChange={handleInputEmail} onKeyPress={handleKeyPress}
                            />
                        </FormGroup>
                    </Form>
                </ModalBody>

                <ModalFooter>
                    <button className={`btn third ${isLoaded ? " disabled" : ''}`}
                            onClick={isLoaded ? null : sendForm}>Sign Up
                    </button>
                    {' '}
                    <button className={`btn first ${isLoaded ? " disabled" : ''}`}
                            onClick={isLoaded ? null : toggle}>Cancel
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

ModalSignUp.propTypes = {
    signUp: PropTypes.func,
    clearError: PropTypes.func,
    isLoaded: PropTypes.bool,
    isError: PropTypes.bool,
    toggle: PropTypes.func,
    setSuccessText: PropTypes.func,
    toggleSuccess: PropTypes.func,
    isOpen: PropTypes.bool,
};

export default connect(null, dispatch => ({
            signUp: (data) => dispatch(signUp(data)),
            clearError: () => dispatch(setErrorProfile(false)),
        })
)(ModalSignUp);
